import script from "./WelcomeLoginView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeLoginView.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeLoginView.vue?vue&type=style&index=0&id=19b3c90f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b3c90f"]])

export default __exports__